/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const PrintIcon = ({ width = 24, height = 24, hidden = false, title = 'Print' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35 10h-5V3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v7H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h3v7a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-7h3a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1ZM8 4h20v6H8Zm22 28H6V20h24Z"
    />
    <path d="M10 26h16v2H10zM10 22h16v2H10z" />
  </svg>`;
};
